import { inject, Injectable } from '@angular/core';
import { Observable } from 'rxjs';

import type {
  SupplierAllocation,
  SupplierAllocationsParams,
  SupplierAllocationsUpdate,
} from '@ps/survey-utils';

import { SupplierApi } from '../../api/supplier/supplier.api';

@Injectable({ providedIn: 'root' })
export class SupplierService {
  private readonly _api = inject(SupplierApi);

  public allocations(
    surveyId: number,
    params: SupplierAllocationsParams,
  ): Observable<SupplierAllocation[]> {
    return this._api.allocations(surveyId, params);
  }

  public updateAllocations(
    surveyId: number,
    update: SupplierAllocationsUpdate,
  ): Observable<SupplierAllocation[]> {
    return this._api.updateAllocations(surveyId, update);
  }
}
